import { postWithJson } from 'library/utils/serviceUtil'

/**
 * 功能包列表
 */
export const getList = (params = {}) => {
    return postWithJson('/package/list.np', params)
}

/**
 * 新增
 */
export const add = (params = {}) => {
    return postWithJson('/package/add.np', params)
}

/**
 * 编辑
 */
export const mod = (params = {}) => {
    return postWithJson('/package/mod.np', params)
}

/**
 * 获取系统列表
 */
export const systemList = (params = {}) => {
    return postWithJson('/package/system/list.np', params)
}

/**
 * 功能包详情
 */
export const packageDetail = (params = {}) => {
    return postWithJson('/package/info.np', params)
}

/**
 * 删除功能包
 */
export const delPackage = (params = {}) => {
    return postWithJson('/package/del.np', params)
}
